import { render, staticRenderFns } from "./alzx.vue?vue&type=template&id=11cc9f69&scoped=true&"
import script from "./alzx.vue?vue&type=script&lang=js&"
export * from "./alzx.vue?vue&type=script&lang=js&"
import style0 from "./alzx.vue?vue&type=style&index=0&id=11cc9f69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cc9f69",
  null
  
)

export default component.exports